export const formatarData = (date) => {
  if (!date) return "-";

  try {
    // Se já está no formato brasileiro, retorna como está
    if (typeof date === "string" && date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      return date;
    }

    // Se for string no formato YYYY-MM-DD
    if (typeof date === "string" && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [year, month, day] = date.split("-");
      const localDate = new Date(year, month - 1, day);
      return localDate.toLocaleDateString("pt-BR");
    }

    // Se for array (LocalDate do Java)
    if (Array.isArray(date) && date.length >= 3) {
      const [year, month, day] = date;
      const localDate = new Date(year, month - 1, day);
      return localDate.toLocaleDateString("pt-BR");
    }

    // Para outros formatos
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
      return "-";
    }

    return dateObj.toLocaleDateString("pt-BR");
  } catch (error) {
    return "Data invalida";
  }
};

// utils/FormatarData.js
export const formatarDataDaAPI = (dateStr) => {
  if (!dateStr || dateStr === null || dateStr === undefined) {
    return "";
  }
  try {
    if (dateStr.includes("/")) {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return dateStr;
  } catch (error) {
    console.error("Erro na formatação de data:", error);
    return "";
  }
};

export const obterDataAtual = () => {
  const hoje = new Date();
  const dia = String(hoje.getDate()).padStart(2, "0");
  const mes = String(hoje.getMonth() + 1).padStart(2, "0");
  const ano = hoje.getFullYear();
  return `${dia}/${mes}/${ano}`;
};
